import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetUserLoading, EGetUserActionTypes } from './types';

export const getUserLoading: () => TGetUserLoading = actionGenerator<EGetUserActionTypes.Loading>(
  EGetUserActionTypes.Loading,
);
